module.exports = __webpack_public_path__ + "static/media/face_detection.7fdfb250.png";